import React, { useState, useEffect, useMemo } from "react";
import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { ServiceProvider } from "./hocs/ServcieProvder";
import { Provider } from "react-redux";
import api from "./services/api";
import store from "./store";
import { ServiceContainer } from "./hocs/withServices";
import { AppContainer } from "./components/containers/App";
import { Router } from "./pages/router";
import "./assets/styles/reset.css";
import "./assets/styles/global.css";
import "./assets/styles/fontface.css";
import "./assets/styles/main.css";
import "./assets/styles/landing.css";
import { apiURL } from "./config/keys";

const App = () => {
  const [serviceContainer] = useState<ServiceContainer>({
    api: api(apiURL || ""),
  });
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  const router = useMemo(() => AppContainer(Router), []);

  return (
    <ServiceProvider value={{ serviceContainer, setContainer: () => undefined }}>
      <Provider store={store}>{loaded && router({})}</Provider>
    </ServiceProvider>
  );
};

declare global {
  interface Window {
    api?: unknown;
    ethereum?: unknown;
    reload?: unknown;
  }
}

ReactDOM.render(
  <BrowserRouter>
    <App />
  </BrowserRouter>,
  document.getElementById("root")
);
